import axios from 'axios';
import $ from 'jquery';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import '../assets/css/font/Banikanta-normal'
import imageCompression from 'browser-image-compression';
import androidchrome from '../assets/images/logo-forest.png'
import { Dictionary_URL, DOWNLOADIMAGEFRA_URL } from '../services/end-url';
export const MAX_FILE_SIZE = 5.2 * 1024 * 1024;
export const MAX_LENGTH = 9
export const MAX_VIDEO_SIZE = 20 * 1024 * 1024;;



export const GenerateToken = async (user) => {
    await axios.post(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.Common + 'api/Authenticate/Authenticate', {
        userName: "a@aa.com",
        password: "1234567",
        role: "na"
    })
        .then(function (response) {
            try {
                globalThis.config.Settings.token = response.data.jwtToken

            }
            catch (e) {
                alert(e.message.toString());
            }

        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .finally(function () {
            // always executed
        });
}
export const GetMasterCommon = async (ids) => {
    let data;
    await axios.get(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.Common + 'api_common/CommonApi/' + ids,
        { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
        .then(function (response) {
            data = response;
        })
        .catch(function (error) {
            data = null;
        })
        .finally(function () {

        });
    return data.data;
}
export const GetMasterAgency = async () => {
    let data;
    await axios.get(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.PMIS + 'api/PMISApi/GetAgencySitesMater',
        { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
        .then(function (response) {
            data = response;
        })
        .catch(function (error) {
            data = null;
        })
        .finally(function () {

        });
    return data.data;
}

export const GetTokenArcGis = async (param) => {
    const api = axios.create({
        baseURL: globalThis.config.Settings.MapConfig.GetTokenBaseUrl,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    try {
        const response = await api.post('generateToken', param);
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}
export const GetCreateUserArcGis = async (param) => {
    const api = axios.create({
        baseURL: globalThis.config.Settings.MapConfig.CreateUserBaseUrl,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    try {
        const response = await api.post('createUser', param);
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}
export const GetDictionary = async (gids) => {
    await AutoAuthenticate();
    let dictData = {};
    await axios.get(globalThis.config.Settings.ApiConfiguration.Host + Dictionary_URL + "?id=" + gids,
        { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
        .then(function (response) {
            if (response.data) {
                response.data.forEach(function (idx) {
                    if (globalThis.config.Settings.Locale == "en") {
                        dictData[idx.message.trim().replace(/\s/g, '_')] = idx.translation_en;
                    }
                    else {
                        dictData[idx.message.trim().replace(/\s/g, '_')] = idx.translation_as;
                    }
                })
            }
        })
        .catch(function (error) {
            dictData = null;
        })
        .finally(function () {

        });
    return dictData;
}
export const BindDropdown = async (data, id, key, value) => {
    try {
        $("#" + id).empty();
        if (globalThis.config.Settings.Locale == 'en') {
            $("#" + id).append("<option value='' >--Choose--</option>");
        }
        else {
            $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
        }
        if (data.length !== undefined && data.length > 0) {
            data.forEach(function (idx) {
                $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>");
            })
        }
    } catch (e) {
        console.log(e)
    }

}
export const BindDropdownwithoutLang = async (data, id, key, value) => {
    $("#" + id).empty();
    if (globalThis.config.Settings.Locale == 'en') {
        $("#" + id).append("<option value='' >--Choose--</option>");
    }
    else {
        $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
    }
    if (data.length !== undefined && data.length > 0) {
        data.forEach(function (idx) {
            $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value] + "</option>");
        })
    }
}
export const BindDropdownCSSClass = async (data, classname, key, value) => {
    $("." + classname).empty();
    if (globalThis.config.Settings.Locale == 'en') {
        $("." + classname).append("<option value='' >--Choose--</option>");
    }
    else {
        $("." + classname).append("<option value='' >--বাছনি কৰক--</option>");
    }
    if (data.length !== undefined && data.length > 0) {
        data.forEach(function (idx) {
            $("." + classname).append("<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>");
        })
    }
}
export const GetOptionDropdown = async (data, key, value) => {
    var opt = "";
    if (globalThis.config.Settings.Locale == 'en') {
        opt += "<option value='' >--Choose--</option>";
    }
    else {
        opt += "<option value='' >--বাছনি কৰক--</option>";
    }
    if (data.length !== undefined && data.length > 0) {
        data.forEach(function (idx) {
            opt += "<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>";
        })
    }
    return opt;
}
export const GetOptionChoose = async () => {
    var opt = "";
    if (globalThis.config.Settings.Locale == 'en') {
        opt += "<option value='' >--Choose--</option>";
    }
    else {
        opt += "<option value='' >--বাছনি কৰক--</option>";
    }
    return opt;
}
export const fileToDataUri = async (image) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            resolve({
                base64: reader.result,
            });
        });
        reader.readAsDataURL(image);
    });
};
// E.g:- OnKeyPress={IsEmail}  -- allow only alphabet,numeric,@,.
export const IsEmail = (e) => {
    const isValidInput = /^[a-zA-Z0-9@.]+$/.test(e.key);

    if (!isValidInput) {
        e.preventDefault();
    }
    return true
};
export const downloadImage = async (url, imageName) => {
    const originalImage = globalThis.config.Settings.ApiConfiguration.Host + url + "?id=" + imageName;
    const image = await fetch(originalImage);
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)
    const link = document.createElement('a')
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return true;
};

export const FormatDate = (inputDate) => {
    if (inputDate != undefined && inputDate != '') {
        const date = new Date(inputDate);
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }
};
export const parseDate = (dateString) => {
    const [day, month, year] = dateString.split('-');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthIndex = monthNames.indexOf(month);
    return new Date(year, monthIndex, day);
};


export const getYear = (inputDate) => {
    if (inputDate !== undefined && inputDate !== '') {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        return year.toString();
    }
    return '';
};

export const FormatDateWithTime = (inputDate) => {
    if (inputDate) {
        const date = new Date(inputDate);
        const year = date.getUTCFullYear();
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const day = date.getUTCDate().toString().padStart(2, '0');
        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');
        const seconds = date.getUTCSeconds().toString().padStart(2, '0');
        const milliseconds = date.getUTCMilliseconds().toString().padStart(3, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    }

    return '';
};
export const getMonth = (inputDate) => {
    if (inputDate) {
        const date = new Date(inputDate);
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        return `${month}`;
    }
}
export const RandomColorHex = (index) => {
    let letters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    // HTML color code starts with #
    let color = '#';
    // Generating 6 times as HTML color code
    // consist of 6 letter or digits
    for (let i = 0; i < 6; i++) {
        color += letters[(Math.floor(Math.random() * 16))];
    }
    return color;
};
export const downloadImagefra = async (url, imageName) => {
    const originalImage = globalThis.config.Settings.ApiConfiguration.Host + DOWNLOADIMAGEFRA_URL + "?id=" + imageName;
    const image = await fetch(originalImage);
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)
    const link = document.createElement('a')
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return true;
};
export const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to month because it's 0-based
    const day = now.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export const WKTStringToArray = (wktString) => {
    try {
        let polygonParts = null;
        if (wktString.startsWith('POLYGON')) {
            polygonParts = wktString.match(/\(\(([^()]+)\)\)/g);
            if (polygonParts == null) {
                polygonParts = wktString.match(/\(\s*(.*?)\s*\)/g);
            }
            if (polygonParts) {
                if (polygonParts.length === 1) {
                    // Simple polygon case
                    const coordinatesPart = polygonParts[0].substring(2, polygonParts[0].length - 2);
                    const coordinateStrings = coordinatesPart.split(', ');
                    const coordinatesArray = coordinateStrings.map(coordString => {
                        const [lon, lat] = coordString.split(' ').map(parseFloat);
                        return [lon, lat];
                    });
                    return [coordinatesArray];
                } else {
                    // Polygon with holes case
                    const rings = polygonParts.map((polygonPart, index) => {
                        const coordinatesPart = index === 0 ?
                            polygonPart.replace(/^\(\(\s*|\s*\)\)$/g, '') : // Remove leading and trailing double parentheses for outer polygon
                            polygonPart.replace(/^\(\s*|\s*\)$/g, ''); // Remove leading and trailing parentheses for inner rings

                        const coordinateStrings = coordinatesPart.split(', ');
                        return coordinateStrings.map(coordString => {
                            const [lon, lat] = coordString.split(' ').map(parseFloat);
                            return [lon, lat]; // Reversed to [lon, lat] format
                        });
                    });

                    return rings;
                }

            }
        } else if (wktString.startsWith('MULTIPOLYGON')) {
            // Multipolygon case
            const finalcoordinates = [];
            const polygonParts = wktString.match(/\(\(([^()]+)\)\)/g);
            polygonParts.forEach((polygonPart) => {
                const coordinatesPart = polygonPart.substring(2, polygonPart.length - 2);
                const coordinateSets = coordinatesPart.split('), (');
                coordinateSets.forEach((coordSet) => {
                    const coordinateStrings = coordSet.split(', ');
                    const coordinates = coordinateStrings.map((coordString) => {
                        const [lon, lat] = coordString.split(' ').map(parseFloat);
                        return [lon, lat];
                    });

                    finalcoordinates.push(coordinates);
                });
            });
            return finalcoordinates;
        } else {
            throw new Error('Unsupported WKT format: Only POLYGON and MULTIPOLYGON are supported.');
        }
    } catch (error) {
        console.error('Error:', error);
        throw error; // Rethrow the error if needed
    }
};



export const WKTStringToArray_new = (wktString) => {
    try {
        let polygonParts = null;
        if (wktString.startsWith('POLYGON')) {
            polygonParts = wktString.match(/\(\(([^()]+)\)\)/g);
            if (polygonParts == null) {
                polygonParts = wktString.match(/\(\s*(.*?)\s*\)/g);
            }
            if (polygonParts) {
                if (polygonParts.length === 1) {
                    // Simple polygon case
                    const coordinatesPart = polygonParts[0].substring(2, polygonParts[0].length - 2);
                    const coordinateStrings = coordinatesPart.split(', ');
                    const coordinatesArray = coordinateStrings.map(coordString => {
                        const [lon, lat] = coordString.split(' ').map(parseFloat);
                        return [lon, lat];
                    });
                    return [coordinatesArray];
                } else {
                    // Polygon with holes case
                    const rings = polygonParts.map((polygonPart, index) => {
                        const coordinatesPart = index === 0 ?
                            polygonPart.replace(/^\(\(\s*|\s*\)\)$/g, '') : // Remove leading and trailing double parentheses for outer polygon
                            polygonPart.replace(/^\(\s*|\s*\)$/g, ''); // Remove leading and trailing parentheses for inner rings

                        const coordinateStrings = coordinatesPart.split(', ');
                        return coordinateStrings.map(coordString => {
                            const [lon, lat] = coordString.split(' ').map(parseFloat);
                            return [lon, lat]; // Reversed to [lon, lat] format
                        });
                    });

                    return rings;
                }

            }
        } else if (wktString.startsWith('MULTIPOLYGON')) {
            // Multipolygon case
            const finalcoordinates = [];
            const polygonParts = wktString.match(/\(\(([^()]+)\)\)/g);
            polygonParts.forEach((polygonPart) => {
                const coordinatesPart = polygonPart.substring(2, polygonPart.length - 2);
                const coordinateSets = coordinatesPart.split('), (');
                coordinateSets.forEach((coordSet) => {
                    const coordinateStrings = coordSet.split(', ');
                    const coordinates = coordinateStrings.map((coordString) => {
                        const [lon, lat] = coordString.split(' ').map(parseFloat);
                        return [lon, lat];
                    });

                    finalcoordinates.push(coordinates);
                });
            });
            return finalcoordinates;
        } else {
            throw new Error('Unsupported WKT format: Only POLYGON and MULTIPOLYGON are supported.');
        }
    } catch (error) {
        console.error('Error:', error);
        throw error; // Rethrow the error if needed
    }
};

// export const UpdateBGImage = async (img) => {
//    document.getElementsByTagName('body')[0].style.background = `url('${img}') 0 0 no-repeat`;
//    document.getElementsByTagName('body')[0].style.backgroundAttachment = `fixed`;
// }
export const UpdateBGImage = async (img) => {
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundImage = `url('${img}')`;
    body.style.backgroundRepeat = 'no-repeat';
    body.style.backgroundAttachment = 'fixed';
    body.style.backgroundPosition = 'top right';
};




export const getSiteList = async (inputDate) => {
    let data;
    await axios.get(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.PMIS + 'api/AddPlantationApi/GetPlantationSite',
        { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
        .then(function (response) {
            data = response;
        })
        .catch(function (error) {
            data = null;
        })
        .finally(function () {

        });
    return data.data;
}
export const checkDuplicateSite = async (site_name) => {
    let data;
    let flag = false
    await axios.get(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.PMIS + 'api/AddPlantationApi/CheckDuplicateSite/' + site_name,
        { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
        .then(function (response) {
            data = response;
            if (data.data.plantation_site[0].site_found > 0) {
                flag = true;
            } else {
                flag = false;
            }

        })
        .catch(function (error) {
            data = null;
        })
        .finally(function () {

        });
    return flag;;
}
export const checkDuplicateAgencySite = async (site_name) => {
    let data;
    let flag = false
    await axios.get(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.PMIS + 'api/AddPlantationApi/CheckDuplicateAgencySite/' + site_name,
        { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
        .then(function (response) {
            data = response;
            if (data.data.agency_site[0].site_found > 0) {
                flag = true;
            } else {
                flag = false;
            }

        })
        .catch(function (error) {
            data = null;
        })
        .finally(function () {

        });
    return flag;;
}
export const AutoAuthenticate = async () => {
    try {
        const response = await axios.get(globalThis.config.Settings.ApiConfiguration.Host +
            globalThis.config.Settings.ApiConfiguration.Microservices.Common + 'api/Authenticate/AutoAuthenticate/' + globalThis.config.Settings.security_key);
        if (response.data) {
            localStorage.setItem("jwtToken", response.data);
        }
    } catch (error) {
        console.log('Error:', error);
    }

}

export const circle_filter = async (data, currentUser) => {
    if (currentUser.lst_working_boudary == undefined || currentUser.lst_working_boudary == null) {
        return data;
    }
    let lst_working_boudary = currentUser.lst_working_boudary;
    if (lst_working_boudary.length > 0) {
        if (lst_working_boudary[0].circle_id != 0) {
            data = data.filter((row) => {
                return row.circle_id == lst_working_boudary[0].circle_id
            })
        }
    }
    return data;
}
export const division_filter = async (data, currentUser) => {
    if (currentUser.lst_working_boudary == null) {
        return data;
    }
    let lst_working_boudary = currentUser.lst_working_boudary;
    if (lst_working_boudary.length > 0) {
        if (lst_working_boudary[0].division_id != 0) {
            data = data.filter((row) => {
                return row.division_id == lst_working_boudary[0].division_id
            })
        }
    }
    return data;
}
export const range_filter = async (data, currentUser) => {
    if (currentUser.lst_working_boudary == null) {
        return data;
    }
    let lst_working_boudary = currentUser.lst_working_boudary;
    if (lst_working_boudary.length > 0) {
        if (lst_working_boudary[0].range_id != 0) {
            data = data.filter((row) => {
                return row.range_id == lst_working_boudary[0].range_id
            })
        }
    }
    return data;
}



export const workingBoudaryFilter = (currentUser) => {
    let working_boundary = currentUser.lst_working_boudary[0].working_boundary

    // let zone_ddl_visible = [1].includes(currentUser.lst_working_boudary[0].wing_id)
    // let circle_ddl_visible = [1, 3, 4].includes(currentUser.lst_working_boudary[0].wing_id)
    // let division_ddl_visible = [1, 2, 3, 4].includes(currentUser.lst_working_boudary[0].wing_id)
    // let pa_ddl_visible = [2].includes(currentUser.lst_working_boudary[0].wing_id)
    // let range_ddl_visible = (currentUser.lst_working_boudary[0].range_id == 0 && [1, 2].includes(currentUser.lst_working_boudary[0].wing_id)) ? true : false;
    // let beat_ddl_visible = (currentUser.lst_working_boudary[0].beat_id == 0 && [1].includes(currentUser.lst_working_boudary[0].wing_id)) ? true : false;
    let rewp_ddl_visible = ([4].includes(currentUser.lst_working_boudary[0].wing_id) && currentUser.lst_working_boudary[0].circle_id == 0 && currentUser.lst_working_boudary[0].division_id == 0);

    switch (working_boundary) {
        case "AFD":
            return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
        case "Wing":
            return { wing_ddl: false, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
        case "Zone":
            return { wing_ddl: false, zone_ddl: false, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
        case "Circle":
            return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
        case "Division":
            return { wing_ddl: false, zone_ddl: false, circle_ddl: rewp_ddl_visible, pa_ddl: false, division_ddl: rewp_ddl_visible, range_ddl: true, beat_ddl: true, office_ddl: true }
        case "Range":
            return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: false, beat_ddl: true, office_ddl: true }
        case "Beat":
            return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: false, beat_ddl: false, office_ddl: true }
        case "National Park":
            return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: false, office_ddl: true }
        default:
            return { wing_ddl: false, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    }
    // switch (working_boundary) {
    //   case "AFD":
    //     return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //   case "Wing":
    //     return { wing_ddl: false, zone_ddl: zone_ddl_visible, circle_ddl: circle_ddl_visible, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: true, office_ddl: true }
    //   case "Zone":
    //     return { wing_ddl: false, zone_ddl: false, circle_ddl: circle_ddl_visible, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
    //   case "Circle":
    //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
    //   case "Division":
    //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
    //   case "Range":
    //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
    //   case "Beat":
    //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
    //   default:
    //     return { wing_ddl: true, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: false, beat_ddl: false, office_ddl: true }
    // }
    // let wing_id = currentUser.lst_working_boudary[0].wing_id;
    // if (wing_id == 1) {
    //   switch (working_boundary) {
    //     case "AFD":
    //       return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Wing":
    //       return { wing_ddl: false, zone_ddl: true, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Zone":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Circle":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Division":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Range":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: true, office_ddl: true }
    //     case "Beat":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
    //     default:
    //       return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //   }
    // }
    // else if (wing_id == 2) {
    //   switch (working_boundary) {
    //     case "AFD":
    //       return { wing_ddl: true, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Wing":
    //       return { wing_ddl: false, zone_ddl: true, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Zone":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Circle":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Division":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //     case "Range":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: true, office_ddl: true }
    //     case "Beat":
    //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
    //     default:
    //       return { wing_ddl: true, zone_ddl: true, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    //   }
    //}
}


export const GetPermissionAll = async (resource_id) => {
    let permission = { view: false, add: false, edit: false, approve_reject: false, assign: false };
    // let get_permission = JSON.parse(localStorage.getItem("accessmatrix")).Permissions
    let get_permission = JSON.parse(JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth).user.accessmatrix).Permissions
    if (typeof get_permission !== 'undefined' && get_permission != "") {
        get_permission.forEach((el) => {
            if (el.resource_id == resource_id && el.permission_id == 1) {
                permission.view = true;
            }
            else if (el.resource_id == resource_id && el.permission_id == 2) {
                permission.add = true;
            }
            else if (el.resource_id == resource_id && el.permission_id == 3) {
                permission.edit = true;
            }
            else if (el.resource_id == resource_id && el.permission_id == 4) {
                permission.approve_reject = true;
            }
            else if (el.resource_id == resource_id && el.permission_id == 5) {
                permission.assign = true;
            }
        });
    }
    return permission;
}
// export const GetPermission = (resource_id, permission_id) => {
//     let bool = false;
//     let get_permission = JSON.parse(localStorage.getItem("accessmatrix")).Permissions
//     if (typeof get_permission !== 'undefined' && get_permission != "") {
//         get_permission.forEach((el) => {
//             if (el.resource_id == resource_id && el.permission_id == permission_id) {
//                 bool = true;
//                 return bool;
//             }
//         });
//     }

//     return bool;
// }


export const GetPermission = (resource_id, permission_id) => {
    let bool = false;
    // globalThis.config.Settings.ApiConfiguration.Permissions.forEach((el) => {
    //     if (el.resource_id == resource_id && el.permission_id == permission_id) {
    //         bool = true;
    //         return bool;
    //     }

    // });
    return true;
}

export const FileCompression = async (img) => {
    if (img.type.includes("image/")) {
        let img_name_size = await imageCompression(img, globalThis.config.Settings.img_compress_options);
        let img_base64 = await imageCompression.getDataUrlFromFile(img_name_size)
        return {
            name: img_name_size.name,
            size: img_name_size.size,
            img_base64: img_base64
        };
    }
    else {
        return {
            name: img.name,
            size: img.size,
            img_base64: (await fileToDataUri(img)).base64
        };
    }
};

export const IsNumberKey = (e) => {
    const isValidInput = /^[0-9\b]+$/.test(e.key);
    if (!isValidInput) { e.preventDefault(); }
};



export const IsAlphabetNumber = (e) => {
    const isValidInput = /[^a-zA-Z0-9]/.test(e.key);
    if (isValidInput) { e.preventDefault(); }
};


export const IsAlphabetKey_space = (e) => {
    const isValidInput = /^[a-zA-Z0-9\s]+$/.test(e.key);
    if (!isValidInput) { e.preventDefault(); }
};

export const IsAlphabetKey = (e) => {
    const isValidInput = /^[a-zA-Z\s]+$/.test(e.key);
    if (!isValidInput) { e.preventDefault(); }
};
export const IsNumberDecimalKey = (e) => {
    const isValidInput = /^[0-9.]*$/.test(e.key);
    if (!isValidInput || ((e.target.value + '' + e.key).split('.').length > 2)) {
        e.preventDefault();
    }
};


export const Pdf_log = async () => {
    const doc = new jsPDF();

    const logoUrl = androidchrome;
    const logoWidth = 20;
    const logoHeight = 20;
    const padding = 8;

    doc.addImage(logoUrl, 'PNG', padding, padding, logoWidth, logoHeight);

    const headerX = padding + logoWidth + 5;

    const firstHeaderY = padding + (logoHeight / 3);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(globalThis.config.Settings.Locale === "en" ? "Government of Assam" : "অসম চৰকাৰ", headerX, firstHeaderY);

    const secondHeaderY = firstHeaderY + 6;
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(
        globalThis.config.Settings.Locale === "en"
            ? "Plantation Management Information System"
            : "বাগিচা ব্যৱস্থাপনা তথ্য ব্যৱস্থা",
        headerX,
        secondHeaderY
    );
    return doc;
};

export const Pdf_Set_css = async () => {
    const logoHeight = 20;
    const padding = 10;
    const spaceBelowLogo = 2;
    const tableStartY = padding + logoHeight + spaceBelowLogo;

    return tableStartY;
};

export const ListPdfDownload = async (
    columns = [],
    formattedData = [],
    pdf_name = 'assam.pdf',
    header = [],
    type = 'l'
) => {
    // Handle empty data case
    if (formattedData.length === 0) {
        const columnTitle = columns[0]?.title || 'Message';
        formattedData = [
            {
                [columnTitle]: 'No data found',
                _colSpan: columns.length - 1,
            },
        ];
    }

    const doc = new jsPDF(type);
    const pageWidth = doc.internal.pageSize.getWidth();

    // ------------------ Add Logo -------------------------
    const logoUrl = androidchrome;
    const logoWidth = 20;
    const logoHeight = 20;
    const padding = 12;
    const logoX = padding;
    const logoY = padding;
    doc.addImage(logoUrl, 'PNG', logoX, logoY, logoWidth, logoHeight);

    // ------------------ Add Text Beside Logo -------------------------
    const headerX = logoX + logoWidth + 5;
    const firstHeaderY = logoY + logoHeight / 3;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('Government of Assam', headerX, firstHeaderY);

    const secondHeaderY = firstHeaderY + 8;
    doc.setFontSize(12);
    doc.text('Plantation Management Information System', headerX, secondHeaderY);

    // ------------------ Calculate Table Start Position -------------------------
    const spaceBelowLogo = 10;
    let tableStartY = logoY + logoHeight + spaceBelowLogo;

    // ------------------ Optional Additional Headers -------------------------
    header.forEach((text) => {
        if (text) {
            const textWidth = doc.getTextWidth(text);
            const x = (pageWidth - textWidth) / 2;
            const y = tableStartY;
            tableStartY += 10;
            doc.setFont('helvetica', 'normal');
            doc.text(text, x, y);
        }
    });

    // ------------------ Generate Table -------------------------
    doc.autoTable({
        columns,
        body: formattedData,
        startY: tableStartY,
        columnWidth: 20,
        willDrawCell: function () {
            doc.setFont('helvetica', 'normal');
        },
        didParseCell: function (data) {
            data.cell.styles.minCellWidth = 30;
        },
    });

    // ------------------ Save PDF -------------------------
    doc.save(pdf_name);
};

export const money_without_commas = (input) => {
    if (typeof input !== 'string') return input;
    return parseFloat(input.replace(/,/g, ''));
};
export const money_with_commas_pmis = (input) => {
    if (input == null || input === '') return '';

    const parts = input.toString().split('.');
    let integerPart = parts[0];
    const decimalPart = parts.length > 1 ? '.' + parts[1] : '';

    // Apply Indian comma formatting
    const lastThree = integerPart.slice(-3);
    const otherNumbers = integerPart.slice(0, -3);
    const formattedOther = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

    return (otherNumbers ? formattedOther + ',' : '') + lastThree + decimalPart;
};




